/**
 * CLEAR brand mark: a three-blade fan rotor (what the line assembles) turning around a
 * green hub (the "ready" signal). Drawn in currentColor so it works on any background.
 */
export function Logo({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <g fill="currentColor">
        {[0, 120, 240].map((a) => (
          <path
            key={a}
            d="M16 16 C 12.4 12.6 10.6 6.4 13.6 1.6 C 18.8 1.2 21.8 7.2 19.6 13.2 Z"
            transform={`rotate(${a} 16 16)`}
          />
        ))}
      </g>
      <circle cx="16" cy="16" r="4.2" fill="#2BB36A" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}
